import './jobs-contact-overview.scss';

import { Slider } from '../../components/slider/slider';

class JobsContactOverview {
    constructor (element, options) {
        const settings = {
            resizeTimeout: 150
        };

        this.settings = Object.assign({}, settings, options);
        this.resizeHandler = options.resizeHandler;

        this.$jobsContactSlider = element;

        this.sliderAPI = null;
    }

    initialize () {
        this.checkSize();
        this.setEvents();
    }

    setEvents () {
        this.resizeHandler.customFunctions.push(() => {
            this.checkSize();
        });
    }

    checkSize () {
        if (window.innerWidth < 768) {
            if (this.sliderAPI === null) {
                this.initSlider();
            }
        } else {
            if (this.sliderAPI) {
                this.destroySlider();
            }
        }
    }

    initSlider () {
        if (!this.sliderAPI) {
            this.sliderAPI = new Slider(this.$jobsContactSlider, {
                freeMode: true,
                // scrollbar: true,
                speed: 500,
                spaceBetween: 15,
                slidesPerView: 1,
                initAttr: 'data-jobs-contact-slider',
                prevnext: false,
                mousewheel: {
                    forceToAxis: true,
                    invert: true
                },
                breakpoints: null,
                resizeEvent: 'auto',
                observer: true,
                observeParents: true,
                parallax: true
            });
        }
    }

    destroySlider () {
        if (this.sliderAPI) {
            this.sliderAPI.destroy();
            this.sliderAPI = undefined;
        }
    }
}

export { JobsContactOverview };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$jobsContactOverviews = $context.querySelectorAll('[data-jobs-contact-slider="root"]');

        if ($$jobsContactOverviews.length > 0) {
            for (let i = 0; i < $$jobsContactOverviews.length; i++) {
                const $jobsContactsSlider = new JobsContactOverview($$jobsContactOverviews[i], {
                    resizeHandler: window.resizeHandler
                });
                $jobsContactsSlider.initialize();
            }
        }
    }
});
